export const layoutModeEnum = {
	default: 'container',
	headerFullContent: 'header-full-content--opened',
	sideFullContent: 'side-full-content--opened'
}
